// public/v3/src/lib/preset-program.js
// Pure helper: returns the CPT code an activity-log entry should carry,
// derived from a preset's programFamily and the patient's billing slots.
//
// In the All lens, presets from CCM, BHI, Pain, and PIN sources are interleaved in a single
// list; the previous `programFilter === 'bhi' ? bhi : ccm` ternary in
// time-logs.jsx#buildEntry meant All-view logging always wrote the CCM CPT
// regardless of preset origin. This helper restores per-preset accuracy.

function cptForPreset(preset, patient) {
  if (!preset || !patient) return '';
  const billing = (patient._raw && patient._raw.billing) || {};
  if (preset.programFamily === 'bhi') return billing.bhiProgram || '';
  if (preset.programFamily === 'pain') return billing.painProgram || '';
  if (preset.programFamily === 'pin') return billing.navProgram || '';
  return billing.program || '';
}

function hasProgram(value) {
  const s = String(value || '').trim();
  return !!s && s.toLowerCase() !== 'none';
}

function canLogPresetForPatient(preset, patient) {
  if (!preset || !patient) return false;
  const raw = patient._raw || patient || {};
  const billing = raw.billing || {};
  if (preset.programFamily === 'bhi') {
    return hasProgram(billing.bhiProgram) && raw.bhiConsent && raw.bhiConsent.signed === true;
  }
  if (preset.programFamily === 'pain') {
    // CPM has its OWN consent record (pain.consent, with coinsurance +
    // right-to-discontinue disclosures) — global CCM consent no longer
    // qualifies (CPM plan P0.2). Legacy pain enrollees can't log CPM time
    // until staff complete the CPM record via the Onboard backfill chip.
    return hasProgram(billing.painProgram) && !!(raw.pain && raw.pain.consent && raw.pain.consent.signed === true);
  }
  if (preset.programFamily === 'pin') {
    return billing.navProgram === 'G0023';
  }
  return hasProgram(billing.program) && raw.consent === 'signed';
}

module.exports = { cptForPreset, canLogPresetForPatient };
